export default "/images/49980c51b81704114e16c55f2552afd7.png";